import React from 'react'
import { Users, TrendingUp, Clock, BarChart3 } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

const FeaturesSection = () => {
  const navigate = useNavigate()

  const handleStartTrial = () => {
    navigate('/signup')
  }

  const features = [
    {
      icon: Users,
      title: '"How busy was I today?"',
      description: 'Daily traffic counts.',
      color: 'blue'
    },
    {
      icon: TrendingUp,
      title: '"Am I trending up or down?"',
      description: 'Compare day, week, month.',
      color: 'green'
    },
    {
      icon: Clock,
      title: '"When should I staff more?"',
      description: 'Peak hours graph.',
      color: 'purple'
    },
    {
      icon: BarChart3,
      title: '"Is my marketing working?"',
      description: 'Campaign uplift tracking.',
      color: 'orange'
    }
  ]

  const getColorClasses = (color: string) => {
    switch (color) {
      case 'blue':
        return { bg: 'bg-blue-100', icon: 'text-blue-600' }
      case 'green':
        return { bg: 'bg-green-100', icon: 'text-green-600' }
      case 'purple':
        return { bg: 'bg-purple-100', icon: 'text-purple-600' }
      case 'orange':
        return { bg: 'bg-orange-100', icon: 'text-orange-600' }
      default:
        return { bg: 'bg-gray-100', icon: 'text-gray-600' }
    }
  }

  return (
    <section id="features" className="section-padding bg-gray-50">
      <div className="container-padding">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            The answers you've been missing — now in your pocket.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const colors = getColorClasses(feature.color)
            const Icon = feature.icon

            return (
              <div key={index} className="text-center group">
                <div className={`w-16 h-16 ${colors.bg} rounded-lg flex items-center justify-center mx-auto mb-4 transition-transform duration-200 group-hover:scale-110`}>
                  <Icon className={`w-8 h-8 ${colors.icon}`} />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            )
          })}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={handleStartTrial}
            className="btn-primary"
          >
            30-Day Risk-Free Trial
          </button>
          <p className="text-sm text-gray-500 mt-2">
            Hardware ships after signup. Trial converts to $99/month unless canceled.
          </p>
        </div>
      </div>
    </section>
  )
}

export default FeaturesSection
